// import 'normalize.css'
import './styles/index.scss'

import './utils/rem'
// import './utils/weixin'

import Vue from 'vue'
import App from './App'
import router from './router'


// import { Field, Radio } from 'mint-ui'

// Vue.component(Field.name, Field)
// Vue.component(Radio.name, Radio)

import MtRadio from 'mint-ui/lib/radio'
import Spinner from 'mint-ui/lib/spinner'
import Button from 'mint-ui/lib/button'
import Popup from 'mint-ui/lib/popup'
import Picker from 'mint-ui/lib/picker'

// import 'mint-ui/lib/radio/style.css';
import 'mint-ui/lib/style.css';

// import waves from './directives/waves'
// Vue.use(waves)
import { Field } from 'mint-ui'

Vue.component(Field.name, Field);
Vue.component(MtRadio.name, MtRadio)
Vue.component(Spinner.name, Spinner)
Vue.component(Button.name, Button)
Vue.component(Popup.name, Popup)
Vue.component(Picker.name, Picker)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js